"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineItemSharedFields = exports.BillingSharedFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const CommercialLineItemType_1 = require("./CommercialLineItemType");
exports.BillingSharedFields = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    metadata: common_1.MetaData,
});
exports.LineItemSharedFields = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    sku: CommercialLineItemType_1.CommercialLineItemType,
    name: typebox_1.Type.String(),
    unitPrice: typebox_1.Type.Optional(typebox_1.Type.Integer({ description: 'in cents' })),
    percentValue: typebox_1.Type.Optional(typebox_1.Type.Number({
        minimum: 0,
        maximum: 10000,
        description: 'in basis points (i.e. percent * 100)',
    })),
    quantity: typebox_1.Type.Number(),
    lineTotal: typebox_1.Type.Integer(),
    taxable: typebox_1.Type.Boolean(),
    metadata: common_1.MetaData,
});
//# sourceMappingURL=shared.js.map